import { useQuery } from '@apollo/client';
import { GLOBAL_QUERY } from '@/queries/queries';

export interface Global {
  site_name: string;
  site_description: string;
  site_logo?: { url: string; alternativeText?: string };
  site_favicon?: { url: string };
  header: {
    enquire_menu_label: string;
    enquire_menu_link?: any;
    right_side_text?: any;
    menu: { name: string; link: string; image?: { url: string; alternativeText?: string } }[];
    left_side_text: string;
    site_details: any[];
  };
  footer?: any;
  newsletter_overlay_heading?: string;
}

export function useGlobalData() {
  const { data, loading, error } = useQuery<{ global: Global }>(GLOBAL_QUERY);
  return { global: data?.global ?? null, loading, error };
}
